export default [
    {
        path: "/notifications",
        name: "notifications",
        component: () => import("./NotificationsPage"),
        meta: { featureName: 'Central de Notificações' }
    }
];
